import { render, staticRenderFns } from "./SocialNetworkAccounts.vue?vue&type=template&id=801a1a60"
import script from "./SocialNetworkAccounts.vue?vue&type=script&lang=js"
export * from "./SocialNetworkAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports